import { render, staticRenderFns } from "./DiseaseComponent.vue?vue&type=template&id=08404d2a&"
import script from "./DiseaseComponent.vue?vue&type=script&lang=js&"
export * from "./DiseaseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports